import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    MdsButtonComponent,
    MdsDialogActionsComponent,
    MdsDialogComponent,
    MdsDialogContentComponent,
} from '@medpacesoftwaredevelopment/designsystem';

export interface DisplayErrorDialogData {
    title?: string | undefined;
    description: string;
    displayCloseButton?: boolean | undefined;
}

@Component({
    selector: 'medpace-display-error-dialog',
    standalone: true,
    imports: [MdsDialogComponent, MdsDialogContentComponent, MdsDialogActionsComponent, MdsButtonComponent],
    templateUrl: './display-error-dialog.component.html',
    styleUrl: './display-error-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisplayErrorDialogComponent {
    bodyText: string;
    bodyLines: string[];
    title: string = 'The operation has not been completed';
    displayCloseButton: boolean = true;

    constructor(
        private dialogRef: MatDialogRef<DisplayErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DisplayErrorDialogData
    ) {
        this.bodyText = data.description;
        this.bodyLines = this.bodyText.split('\n');
        if (data.title) this.title = data.title;
        if (data.displayCloseButton !== undefined) this.displayCloseButton = data.displayCloseButton;
    }

    close() {
        this.dialogRef.close();
    }
}
